import { AxiosError } from "axios";
import { useQuery } from "@tanstack/react-query";
import { apisiseci } from "../../api";
import { Priority } from "../../../@types/priority";

export function usePriorityDetails(id: Priority["id"]) {
  const token = localStorage.getItem("gov_access_token_sso");

  return useQuery<Priority, AxiosError<{ detail: string }>>({
    enabled: !!token,
    queryKey: ['priority', 'details', id],
    queryFn: async () => {
      const response = await apisiseci.get<Priority>(
        `/cms/prioridades/${id}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      return response.data;
    },
  });
}
